import React, { useState } from "react";
import Tab from "./tab";

interface TabData {
  label: string;
  path: string;
}

interface TabsProps {
  tabs: TabData[];
  activeTabIndex?: number;
  onTabClick?: (index: number) => void;
}

const Tabs: React.FC<TabsProps> = ({
  tabs,
  activeTabIndex,
  onTabClick,
}) => {
  const [activeTab, setActiveTab] = useState<number>(activeTabIndex ?? 0);

  const handleTabClick = (index: number) => {
    setActiveTab(index);
    onTabClick && onTabClick(index);
  };

  return (
    <ul className="bcmk-nav nav nav-pills nav-justified">
    {tabs.map((tab, index) => (
          <Tab
            key={index}
            label={tab.label}
            path={tab.path}
            onClick={() => handleTabClick(index)}
            isActive={index === activeTab}
          />
        ))}
  </ul>
  );
};

export default Tabs;
